import { DashboardService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { dashboardKeys } from 'app/queries/dashboard/dashboardKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof dashboardKeys.scriberInfo>>;

export const createFetchScriberDashboardInfoQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(DashboardService.getScriberDashboardInfo({ oid: organizationId }), signal));
